import type { PointerGesturePressDetail } from "../../../../input/PointerGestureInterpreter";
import type { Room } from "../../../../shape/Scene";
import {
  getNearestSelectableSugarModel,
  pickIntersectionForSceneSelection,
  raycast,
  resolveSugarModelClickTarget,
} from "../../../../physics/PhysicsUtil";
import type { Engine } from "../../../../engine/Engine";
import type { SugarModel } from "../../../../loader/SugarModel";
import type { TargetCandidate } from "../TargetCandidate";
import type { Intersection } from "three";
import type { DesignerObject } from "../../object/DesignerObject";

export class ProductTargetPicker {
  constructor(
    private readonly _scene: Room,
    private readonly _engine: Engine,
    private readonly _selected: () => SugarModel | undefined,
    private readonly _createObject: (
      model: SugarModel,
      sourceModel: SugarModel,
      hit: Intersection,
      intersections: Intersection[],
    ) => DesignerObject,
  ) {}

  pick(
    event: PointerGesturePressDetail,
    useSourceModel = false,
  ): TargetCandidate | null {
    const intersections = raycast(event as any, this._scene.models);
    const hit = pickIntersectionForSceneSelection(intersections);
    if (!hit) return null;
    const picked = getNearestSelectableSugarModel(hit.object);
    if (!picked) return null;
    const target =
      resolveSugarModelClickTarget(hit.object, {
        doubleClick: useSourceModel,
        selected: this._selected(),
      }) ?? picked;
    const projected = hit.point
      .clone()
      .project(this._engine.activeCamera!.instance);
    return {
      object: this._createObject(target, picked, hit, intersections),
      depth: projected.z,
      screenDistance: 0,
      priority: 0,
    };
  }
}
